import { DEFAULT_PAGE_SIZE } from '@shared/constants'
import { AnyObject } from 'antd/lib/_util/type'
import { default as queryString, ParsedQuery } from 'query-string'
import { useCallback, useMemo } from 'react'
import { NavigateOptions, useLocation, useNavigate } from 'react-router-dom'

import { useQueryParams } from './useQueryParams'

export const useQueryUpdate = () => {
  const push = useNavigate()
  const location = useLocation()
  const params = useQueryParams()

  const updateQuery = useCallback(
    (
      filters: ParsedQuery | AnyObject,
      reset = false,
      options?: NavigateOptions
    ) => {
      const { pathname, search, hash } = location
      const parsedSearchQuery = queryString.parse(search)

      const isPageChange = 'page' in filters

      const query = reset
        ? filters
        : {
            ...parsedSearchQuery,
            ...filters,
            ...(!isPageChange && { page: 1 })
          }

      const pushURL = queryString.stringifyUrl(
        {
          url: pathname + hash,
          query
        },
        {
          skipEmptyString: true,
          skipNull: true,
          arrayFormat: 'comma'
        }
      )

      if (pathname + search + hash !== pushURL.replace(/\?+$/g, '')) {
        push(pushURL, options)
      }
    },
    [push, location]
  )

  const initParams = useMemo(
    () => ({
      per_page: DEFAULT_PAGE_SIZE,
      page_size: DEFAULT_PAGE_SIZE,
      ...params
    }),
    [params]
  ) as typeof params

  return { params: initParams, updateQuery }
}
